import { xorDecrypt, xorEncrypt } from '../../cryptor/converters';
import {
  GlobalDatabases,
  getGlobalDatabaseInstance,
} from '../manager/databaseManager';
import { PendingQueueStore, QueueInfoKey } from '../schemas/pendingQueueSchema';

//inc num | userId | sheet ids   |  group ids
export type PendingQueueItemKey = [number, string, string[], string[]];
export type PendingQueueItemKeyWithoutSequence = [string, string[], string[]];

const seqNumberSecretKey = 896;

export const getPendingQueueLength = async () => {
  const db = await getGlobalDatabaseInstance(
    GlobalDatabases.PendingQueue,
    GlobalDatabases.PendingQueue
  );

  return await db.table(PendingQueueStore.UnsentQueue).count();
};

export const saveRecordInPendingQueue = async (
  incrementalNumber: number,
  key: PendingQueueItemKey,
  encRecord: string,
  dbName: PendingQueueStore.UnsentQueue | PendingQueueStore.UnprocessedQueue
) => {
  const db = await getGlobalDatabaseInstance(
    GlobalDatabases.PendingQueue,
    GlobalDatabases.PendingQueue
  );

  //   @ts-ignore
  await db.table(dbName).add(encRecord, key);
  const encSequenceNumber = xorEncrypt(incrementalNumber, seqNumberSecretKey);

  const infoKey =
    dbName === PendingQueueStore.UnsentQueue
      ? QueueInfoKey.Unsent
      : QueueInfoKey.UnProcessed;

  await db
    .table(PendingQueueStore.QueueInfo)
    .put([null, null, encSequenceNumber], infoKey);
};

export const deleteRecordFromPendingQueue = async (
  key: PendingQueueItemKey,
  dbName: PendingQueueStore.UnsentQueue | PendingQueueStore.UnprocessedQueue
) => {
  const db = await getGlobalDatabaseInstance(
    GlobalDatabases.PendingQueue,
    GlobalDatabases.PendingQueue
  );

  //   @ts-ignore
  await db.table(dbName).delete(key);
};

export const getLastUsedSequenceNumber = async (
  dbName: PendingQueueStore.UnsentQueue | PendingQueueStore.UnprocessedQueue
): Promise<number> => {
  const errMsg = 'Err!  All Pending Queues Will be deleted';
  const db = await getGlobalDatabaseInstance(
    GlobalDatabases.PendingQueue,
    GlobalDatabases.PendingQueue
  );

  const infoKey =
    dbName === PendingQueueStore.UnsentQueue
      ? QueueInfoKey.Unsent
      : QueueInfoKey.UnProcessed;

  const count = await db.table(dbName).count();
  if (count === 0) {
    return 0;
  }

  const encNumberArray = await db
    .table(PendingQueueStore.QueueInfo)
    .get(infoKey);
  // console.log('encNumberArray', encNumberArray);
  if (!encNumberArray || !Array.isArray(encNumberArray))
    throw new Error(errMsg);

  const encSequenceNumber = encNumberArray[2];
  // console.log('encSequenceNumber', encSequenceNumber);

  if (encSequenceNumber === undefined || isNaN(Number(encSequenceNumber))) {
    throw new Error(errMsg);
  }

  return xorDecrypt(Number(encSequenceNumber), seqNumberSecretKey);
};

export const getEntityDBInfo = async (id: string) => {
  const db = await getGlobalDatabaseInstance(
    GlobalDatabases.PendingQueue,
    GlobalDatabases.PendingQueue
  );

  const entityDBInfo = await db.table(PendingQueueStore.EntityDBInfo).get(id);

  if (
    entityDBInfo &&
    Array.isArray(entityDBInfo) &&
    entityDBInfo[2] !== undefined
  ) {
    if (!isNaN(Number(entityDBInfo[2]))) {
      const activeWAL = xorDecrypt(Number(entityDBInfo[2]));
      return Number(activeWAL);
    } else {
      throw new Error('User record has been manipulated');
    }
  }

  return 0;
};

export const updateEntityDBInfo = async (id: string, activeWAL: number) => {
  const db = await getGlobalDatabaseInstance(
    GlobalDatabases.PendingQueue,
    GlobalDatabases.PendingQueue
  );

  await db
    .table(PendingQueueStore.EntityDBInfo)
    .put([null, null, xorEncrypt(activeWAL)], id);
};
